import React, { Component } from 'react';
import { PropTypes } from 'prop-types'
import { Button, Popover } from 'tinper-bee';
import { observer } from 'mutants-microfx';
import { hotKey } from 'tplus-components-touch';
import { platform } from 'mutants-util';

const buttonMarginHorzontal = 12;
const moreButtonColumns = 4;

@observer
export default class MenuButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showNumber: 0,
            moreVisible: false
        }
        const { isHorizontalPad } = platform || {}
        this.isHorizontalPad = !!isHorizontalPad
    }

    static propTypes = {
        style: PropTypes.object,//显示区域样式
        baseStyle: PropTypes.object,//按钮样式
        hideStyle: PropTypes.object,//隐藏区域样式
        className: PropTypes.string,//组件name
        baseWidth: PropTypes.string,//按钮基本宽度
    }

    clicks = (it) => {
        this.props.clicks(it)
    }

    moreClicks = (it) => {
        this.setState({
            moreVisible: false,
        });
        this.clicks(it);
    }

    //点击更多按钮
    moreButtonClick = () => {
        console.log('点击更多按钮...');
        this.setState({
            moreVisible: true
        });
    }

    //关闭更多
    moreHide = () => {
        this.setState({
            moreVisible: false
        });
    }

    componentDidMount() {
        setTimeout(() => {
            let width = this.wraper.clientWidth;
            let { baseWidth } = this.props;
            let showNumber;
            try {
                showNumber = parseInt((width - buttonMarginHorzontal * 2) / (parseInt(baseWidth)));
                this.setState({ showNumber: showNumber })
            } catch (e) {
                console.warn('baseWidth格式不正确')
            }
        }, 0)
    }

    _getStyles() {
        return {
            moreBtnStyle: {
                width: '86px',
                marginBottom: '12px'
            }
        };
    }

    renderButtons = (buttons, style, click) => {
        return buttons.map((el, index) => {
            return <Button className='action-btn' key={index} style={style} type='default' onClick={() => { click(el) }}>{el.Title}</Button>
        })
    }

    render() {
        var { className, menu, style, baseWidth, baseStyle, hideStyle, collapsed } = this.props;
        const { moreBtnStyle } = this._getStyles();

        const { showNumber, moreVisible } = this.state;

        let baseStyleMap = {
            'boxSizing': 'border-box',
            ...baseStyle,
            width: baseWidth
        }

        let showMenu = [], hideMenu = [], moreButton = null;
        let createMoreMenuContent 
        if (menu.length <= showNumber) {
            showMenu = menu.slice(0, showNumber);
        } else {
            //给更多留一个位置
            showMenu = menu.slice(0, showNumber - 1);
            hideMenu = menu.slice(showNumber - 1);

            //移动端
            if (this.isHorizontalPad) {
                hideMenu = hideMenu.filter(item => item.Name != 'Balance');
            }

            let lastRowLength = hideMenu.length % moreButtonColumns;
            //占位控制
            if (lastRowLength > 0) {
                let occupyLength = moreButtonColumns - lastRowLength;
                for (let i = 0; i < occupyLength; i++) {
                    hideMenu.push({});
                }
            }

            const createMoreMenu = (hideMenu = []) => (
                <div className='overlayWrapped'>
                    {
                        hideMenu.map((item, index) => {
                            const uiState = item.uiState;
                            if (item.Title) {
                                return <Button key={index} className='action-btn' style={moreBtnStyle} type='default' onClick={() => { this.moreClicks(item) }}>{item.Title}</Button>;
                            } else {
                                return <Button key={index} className='action-btn' style={{ ...moreBtnStyle, visibility: 'hidden' }} type='default'>{item.Title}</Button>;
                            }
                        })
                    }
                </div>
            );

            createMoreMenuContent = createMoreMenu(hideMenu);

            moreButton = (
                <Popover
                    className="moreButtonPopover"
                    placement="topRight"
                    positionLeft={collapsed ? '40px' : '91px'}
                    style={{ width: '400px'}}
                    content={createMoreMenuContent}
                    trigger="click"
                    id="leftBottom"
                    show={moreVisible}
                    onHide={this.moreHide}>
                    <Button
                        key={'showMoreButton'}
                        className={hotKey.hotKeyPart('B', 'action-btn')}
                        onClick={this.moreButtonClick}
                        style={baseStyleMap}
                    >更多</Button>
                </Popover>
            );
        }

        const commonButton = this.renderButtons(showMenu, baseStyleMap, this.clicks);

        return (<div className='btn-container hide-dom-tokey' ref={(dom) => { this.wraper = dom }}>
            {commonButton}
            {moreButton}
            <div className="hide-dom-tokey-container">
                {createMoreMenuContent}
            </div>
        </div>)
    }
}